import React from 'react';
import { MdDelete } from 'react-icons/md';
import {
    ADMIN,
    ASSISTANT_MANAGER,
    MANAGER
} from 'components/RoleGate/constants';
import RoleButton from 'components/RoleButton';
import ButtonIconWrapper from 'components/ButtonIconWrapper';

import FertilizerEventHasIncompleteEventsGate from '../FertilizerEventHasIncompleteEventsGate';
import { FERTILIZER_EVENT_DELETE_MODAL } from '../../../../constants';

export default function FertilizerEventDeleteButton(): React.ReactElement {
    return (
        <FertilizerEventHasIncompleteEventsGate>
            <RoleButton
                requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
                params={{
                    [FERTILIZER_EVENT_DELETE_MODAL]: true
                }}
                buttonProps={{
                    icon: true,
                    color: 'black',
                    basic: true,
                    style: {
                        marginRight: 0,
                        marginLeft: 8
                    }
                }}
            >
                <ButtonIconWrapper>
                    <MdDelete
                        style={{
                            fontSize: 20
                        }}
                    />
                </ButtonIconWrapper>
                Delete
            </RoleButton>
        </FertilizerEventHasIncompleteEventsGate>
    );
}
